<template>
    <div class="app-modal-dialog--edit-screen-content app-modal-dialog">
        <div class="app-modal-dialog__content">
            <div class="app-modal-dialog__header">
                <h4 class="app-modal-dialog__title">
                    <span class="app-modal-dialog__subtitle">{{ screen.title }}
                        <span class="element-badge is--accent-03">{{ screen.type.replace('/', ' - ') }}</span>
                    </span>
                    <span class="app-modal-dialog__title">Edit Screen </span>
                    <p class="app-modal-dialog__last-modified">
                        Last Modified: {{ getModifiedDate }}
                    </p>
                </h4>
            </div>
            <form
                @submit.prevent="submit()"
                autocomplete="off">
                <div class="app-modal-dialog__body">
                    <p>You can modify the content of the screen here. You can modify existing fields only.</p>
                    <template v-for="(value, key) in screenFields">
                        <fieldset v-if="editableKey(value.keyName)" class="app-modal-dialog__section" :id="value.fieldset">
                            <label :for="key" class="app-modal-dialog__section-title">
                                {{ getKeyLabels(getKeyName(key)).label }}
                                <svg data-bs-toggle="dropdown" class="element-icon--tooltip-help element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-tooltip-help"></use></svg>
                                <div class="app-tooltip--screen-content-description app-tooltip dropdown-menu">
                                    <h4 class="app-tooltip__title">{{ getKeyLabels(getKeyName(key)).label }}</h4>
                                    <div class="app-tooltip__body">
                                        {{ getKeyLabels(getKeyName(key)).description }}
                                    </div>
                                </div>
                            </label>
                        </fieldset>
                        <field-set v-else-if="value.children?.length > 0"
                            :key="value.fieldset"
                            :field-data="value.children"
                            :top-parent="this"
                            :key-id="value.fieldset">
                        </field-set>
                    </template>
                </div>
                <div class="app-modal-dialog__footer">
                    <app-button
                        theme="danger"
                        class="element-button--secondary element-button"
                        @click="cancel()">
                        Cancel
                    </app-button>
                    <app-button
                        theme="primary"
                        :class="['element-button--primary', 'element-button']"
                        @click="saveContent()">
                        {{ disabled ? 'Saving...' : 'Save' }}
                    </app-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import api from '../api/builder'
import { localizeDate } from '../helpers/util'
//import FieldsetVue from './Fieldset.vue'

export default {
    props: {
        source: {
            type: Object,
        },
        screenSource: {
            type: Object,
        },
        publication: {
            type: Object,
        },
        isLiteMode: {
            type: Boolean,
            default: false
        },
        loId: {
            type: [String, Number],
            default: '0'
        },
        editableKeys: {
            type: Array,
            default: () => [
                '$_title',
                '$_text',
                '$_question',
                '$_response',
                '$_target',
                '$_label',
                '$_directions',
                'correct',
            ]
        },
        sortedKeys: {
            type: Array,
            default: () => [
                '$_title',
                '$_text',
                '$_label',
                'content',
                'block',
                '$_directions',
                '$_question',
                '$_response',
                '$_target',
                'responses',
                'feedback',
                'correct',
                'block-presentation-standard',
                'block-explore-accordion',
                'frontContent',
                'backContent',
                'header',
                'nodes',
                'type',
                'audio',
                'settings',
                'footnotes',
                'eventHooks',
            ]
        },
        fieldSets: {
            type: Object,
            default: () => ({
                'nodes': 'Explore Nodes',
                'header': 'Header',
                'responses': 'Responses',
                'block1': 'Block 1',
                'block2': 'Block 2',
                'feedback': 'Feedback',
                'finalFeedback': 'Final Feedback',
                'pairs': 'Matching Pairs',
                'frontContent': 'Front Content',
                'backContent': 'Back Content',
                'correctFeedback': 'Correct Feedback',
                'incorrectFeedback': 'Incorrect Feedback',
            })
        },
        fieldSetChildren: {
            type: Object,
            default: () => ({
                'nodes': 'Node - {{index}}',
                'pairs': 'Pair - {{index}}',
                'responses': 'Response - {{index}}',
            })
        }
    },
    data () {
        return {
            screen: _.cloneDeep(this.screenSource),
            disabled: false,
        }
    },
    computed: {
        requirementsMet() {
            return this.publication.name.length
        },
        saveUrl() {
            return '/learning/' + this.loId
        },
        screenProps() {
            return this.getDotValues(this.screen.data)
        },
        screenFields() {
            let _path = ''
            return this.getFieldArray(this.screen.data, [], _path)
        },
        getModifiedDate() {
            if (this.screen) {
                let $date = this.screen.updated_at || this.screen.created_at;
                return localizeDate($date).format('MMM D, YYYY h:mm A')
            }
            return null
        },
    },
    methods: {
        cancel () {
            this.$emit('cancel')
        },
        setDisabled(value = true) {
            this.disabled = value
        },
        getModel(_key) {
            let _keyParts = _key.split('.')
            let _model = ''

            _keyParts.forEach((part) => {
                if (_model === '') {
                    _model = "data[" + part + "]"
                } else {
                    _model += "[" + part + "]"
                }
            })

            return _model
        },
        updateScreenData(_key, _value) {
            _.set(this.screen.data, _key, _value)
        },
        getDotValues(data, path = '')
        {
            var $results = {};
            
            _.each(data, (value, key) => {
                if (value && (typeof value === 'object' || typeof value === 'array')) {
                    $results = _.merge($results, this.getDotValues(value, path + key + '.'))
                } else {
                    $results[path + key] = value
                }
            });
            
            return $results;
        },
        sortArrayByKeys(array) {
            // sort the objects in the array based on the keynames using the "this.sortedKeys" as the preferred order
            if (array.length === 0)
                return array
            
            let sortedArray = array.sort((a, b) => {
                let aKey = a.keyName
                let bKey = b.keyName
                
                let aIndex = this.sortedKeys.indexOf(aKey)
                let bIndex = this.sortedKeys.indexOf(bKey)

                // If both keys are in the sortedKeys array, sort by their index
                if (aIndex !== -1 && bIndex !== -1) {
                    return aIndex - bIndex
                }
                // If only one key is in the sortedKeys array, it comes first
                else if (aIndex !== -1) {
                    return -1
                } else if (bIndex !== -1) {
                    return 1
                }
                // If neither key is in the sortedKeys array, maintain original order
                return 0
            });
            
            return sortedArray
        },
        getFieldArray(data, fields, path = '') {
            if (_.isArray(data))
                this.sortArrayByKeys(data)

            _.each(data, (value, key) => {
                if (value && (typeof value === 'object' || typeof value === 'array')) {
                    let _newPath = path + key + '.'
                    let _field = {
                        'fieldset': _newPath,
                        'children': [],
                        'keyName': key,
                    }
                    fields.push(_field)
                    this.getFieldArray(value, _field.children, _newPath)
                } else {
                    fields.push({
                        'fieldset': path + key,
                        'keyName': key,
                        'value': value
                    })
                }
            })
            fields = this.sortArrayByKeys(fields)
            return fields
        },
        editableKey(_key) {
            let keyName = this.getKeyName(_key)
            return this.editableKeyName(keyName)
        },
        editableKeyName(_keyName) {
            return this.editableKeys.includes(_keyName)
        },
        inputTypeByKeyName(_key) {
            switch (_key) {
                case '$_title':
                    return 'text'
                case '$_text':
                    return 'textarea'
                case 'correct':
                    return 'checkbox'
                default:
                    return 'text'
            }
        },
        getKeyName(_key) { // keys are in dot notation, get the last part
            if (!_key)
                return ''

            let _keyParts = _key.split('.')
            return _.last(_keyParts)
        },
        getKeyLabels(_key) {
            switch (_key) {
                case '$_title':
                    return {
                        label: 'Title',
                        description: 'A short name or description that is used to introduce text content.'
                    }
                case '$_text':
                    return {
                        label: 'Text Content',
                        description: 'Information that learners will read or view in order to complete the screen.'
                    }
                case '$_question':
                    return {
                        label: 'Question',
                        description: 'A knowledge check to be answered by the learner.'
                    }
                case '$_directions':
                    return {
                        label: 'Directions',
                        description: 'Instructional text to help guide learners on how to interact with the screen.'
                    }
                case 'correct':
                    return {
                        label: 'Option is correct',
                        description: 'An indication of accuracy in response to the question.'
                    }
                case '$_response':
                    return {
                        label: 'Response',
                        description: 'A reply to the question.'
                    }
                case '$_target':
                    return {
                        label: 'Matching Target',
                        description: 'The corresponding item to a response.'
                    }
                case '$_label':
                    return {
                        label: 'Label',
                        description: 'A title for an explore node.'
                    }
                default:
                    return 'no label found'
            }
        },
        async saveContent() {
            console.info('Saving screen content...')
            this.setDisabled(true)

            var result = null;
            console.log('Screen data before save', this.screen.data)
            
            result = await api.saveChanges(this.saveUrl,  {
                add: [],
                remove: [],
                change: [this.screen]
            })

            console.log('Save result', result)

            if (result && result.id === this.loId)
            {
                this.setDisabled(false)
                this.$emit('screenContentSaved', this.screen)
            }
            else
            {
                console.error('Error saving content', result)
                this.setDisabled(false)
                alert('Error saving content')
            }
        },
    },
    created() {
        console.log('EditScreenContentOverlay created', this.screenFields)
    },
}
</script>
